import { useGlobalSearchParams, useNavigation } from 'expo-router';
import { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedRef } from 'react-native-reanimated';

import { useGetVolunteerEvents } from '@/api/hooks/volunteerHooks';
import DotsLoader from '@/components/DotsLoader';
import { useScrollProps } from '@/components/navigation/TopTabsReanimated';
import VolunteerAnimatedList from '@/components/volunteer/VolunteerAnimatedList';
import useGetLocation from '@/hooks/useGetLocation';

const Volunteer = () => {
  const { npoId } = useGlobalSearchParams<{
    npoId: string;
  }>();

  const {
    data: volunteerEventsResponse,
    isPending,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
    isRefetching
  } = useGetVolunteerEvents({
    n: 0,
    limit: 4,
    npo: npoId
  });

  const volunteerEvents = volunteerEventsResponse?.pages.flatMap((page) => page.results);

  const location = useGetLocation();
  const { scrollTopHeader } = useScrollProps();
  const navigation = useNavigation<any>();
  const flatRef = useAnimatedRef<Animated.FlatList<any>>();

  useEffect(() => {
    const unsubscribe = navigation.addListener('tabPress', () => {
      scrollTopHeader();
      flatRef.current?.scrollToOffset({
        offset: 0,
        animated: false
      });
    });
    return unsubscribe;
  }, [flatRef, navigation, scrollTopHeader]);

  const onEndReached = () => {
    hasNextPage && !isFetching && fetchNextPage();
  };

  return (
    <View style={style.container}>
      {isPending ? (
        <DotsLoader />
      ) : (
        <VolunteerAnimatedList
          volunteerEvents={volunteerEvents}
          location={location}
          npoId={npoId}
          refetch={refetch}
          isFetchingNextPage={isFetchingNextPage}
          onEndReached={onEndReached}
          refreshing={isRefetching}
          canEdit={false}
        />
      )}
    </View>
  );
};

export default Volunteer;

const style = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  }
});
